'use client';

import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useGSAP } from '@gsap/react';
import initAnimation from '../animations/autoplay-chatbox-animation';
import { useTranslation } from 'react-i18next';
import Message from './message';
import {
    buildStaticAssetPath,
    getStaticAssetUrl,
} from '@/app/lib/utils/static-asset-url';

function AutoplayChatbox() {
    const { t } = useTranslation('chat-demo');
    const chatBoxBackgroundImageUrl = getStaticAssetUrl(
        buildStaticAssetPath('bg-chat-box.webp'),
    );

    const demoImages: {
        id: string;
        type: 'NORMAL' | 'MASK';
        name: string;
        url: string;
        batchIndex: string;
        desc: string;
    }[] = t('demoImages', { returnObjects: true }) as {
        id: string;
        type: 'NORMAL' | 'MASK';
        name: string;
        url: string;
        batchIndex: string;
        desc: string;
    }[];

    const rootRef = React.useRef<HTMLDivElement>(null);
    const imageRef = React.useRef<HTMLDivElement>(null);
    const messagesRef = React.useRef<HTMLDivElement>(null);

    const [contianerPosition, setContianerPosition] = useState<
        'top' | 'center' | 'below'
    >('below');

    const [bgUrl, setBgUrl] = useState(
        getStaticAssetUrl('/chat-finger-static-start.webp'),
    );

    // Refactor the nested ternary operation into a separate function
    const updateBgUrl = (position: 'top' | 'center' | 'below') => {
        let url;
        if (position === 'center') {
            url = `${getStaticAssetUrl('/chat-finger.apng')}?t=${new Date().getTime()}`;
        } else if (position === 'top') {
            url = getStaticAssetUrl('/chat-finger-static-start.webp');
        } else {
            url = getStaticAssetUrl('/chat-finger-static-end.webp');
        }
        setBgUrl(url);
    };

    useGSAP(
        () => {
            initAnimation(
                rootRef.current!,
                imageRef.current!,
                messagesRef.current!,
                () => {
                    setContianerPosition('center');
                },
                () => {
                    setContianerPosition('below');
                },
            );
        },
        { scope: rootRef },
    );

    useEffect(() => {
        updateBgUrl(contianerPosition);
    }, [contianerPosition]);

    return (
        <div ref={rootRef} className={'relative h-full w-full'}>
            <div
                ref={imageRef}
                className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center"
                style={{
                    backgroundImage: `url(${chatBoxBackgroundImageUrl})`,
                }}
            >
                <img
                    alt={t('snappingHandGesture')}
                    src={bgUrl}
                    className="h-[300px] w-[300px] sm:h-[480px] sm:w-[480px]"
                />
            </div>

            <div
                ref={messagesRef}
                className={clsx(
                    'absolute bottom-0 left-0 right-0 top-0 flex flex-col gap-[24px] bg-white text-[#000000]',
                )}
            >
                <Message
                    modelName="Simulaix-frontview"
                    sender="Finn Ferral"
                    content="citystreets,sunny day,daylight,trees,cars,buildings,traffic cones"
                    generateImageConfig={{
                        width: 1200,
                        height: 760,
                        steps: 4,
                        cfgScale: 10,
                        imageCount: 4,
                    }}
                    generateImages={demoImages}
                />
            </div>
        </div>
    );
}

export default AutoplayChatbox;
